export default __webpack_public_path__ + "static/media/share-from-square.90f94d49.svg";